import React, { useState, useRef } from "react";

import {
    Box, 
    Paper,
    Divider,
    TextField,
    Switch,
    FormControlLabel,
    FormGroup,
    Checkbox,
    Grid,
    Button,
    Card,
    styled
} from '@mui/material';

import {
  LoadingButton
} from '@mui/lab';

// import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';
// import CommonBreadcumbs from '../../../../components/common/CommonBreadcumbs';
// import CommonSectionHeader from "../common/CommonSectionHeader";

import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { initialValues, validationSchema } from "../../../schema/locations/rackSchema";
import { useTranslations } from "../../../hooks/useTranslations";

import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
// import { CommonIcons, icons } from "../common/CommonIcons";

const StyledCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function NewRack({ parentId, handleOnSuccess }) {

    const { t } = useTranslations({ ns: ["common", "@location"] })

    // const { id } = useParams();
    const { promptMessage } = useSystemPrompt();
    const { isLoading, create } = useLocations({ locationType: locationTypes.rack, targetType: targetTypes.rack });
    const { setSystemLoading } = useAppContextFeatures();

    // const navigate = useNavigate();
    // const { getRoute } = useSystemRoutes(routeTypes.admin);
    // const [ savedValues, setSavedValues ] = useState()

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        // const slots = formik?.values.rows;
        // console.log("VV", formik.errors)

        try{
            
            // let arraySlots = slots.map( i => {
            //     return {
            //         name: i?.slotName,
            //         sequence: i?.slotSequence,
            //         status: i?.slotStatus? 1 : 0,
            //         is_default: i?.defaultSlot? 1 : 0,
            //     }
            // })

            let data = {
                rack: {
                    location_id: parentId,
                    rack_name: currentValues?.rackName,
                    sequence: currentValues?.sequence,
                    is_default : currentValues?.defaultStatus? 1 : 0,
                    status: currentValues?.status? 1 : 0,
                    rack_type: currentValues?.rackType? 1 : 0
                },
                slots: []
            }

            const response = await create({ data });

            promptMessage(true, `${response?.message}`)     

            if(handleOnSuccess) handleOnSuccess()
                
        }catch(error){
            promptMessage(false, `Action Failed (${error?.message})`)
        }   

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { touched, values, errors, handleChange, handleSubmit, setFieldValue } = formik;

    // const handleDeleteRow = (index) => {

    //     let a = formik.values.rows.filter((i, ind) => ind !== index);

    //     if(a.length <= 1){
    //         promptMessage(false, `At least (1) rows`)
    //         return false;
    //     }

    //     formik.setFieldValue(`rows`, a)

    //     return true;

    // }

    // const handleAddItem = () => {

    //     let a = formik.values.rows;

    //     a.push(initialValues.rows[0])

    //     setSavedValues({
    //         ...formik.values,
    //         rows: a
    //     })
    // }

    // const RenderRows = () => {

    //     const rows = values?.rows;

    //     return (
    //         <Box
    //         >
    //             <Box
    //             >
    //                 {
    //                     rows && rows.length > 0
    //                     && rows.map((item, index) => {

    //                         const itemValues = item;
    //                         let itemTouched = touched?.rows
    //                         let itemErrors = errors?.rows

    //                         if(itemTouched){
    //                             itemTouched = (itemTouched[index] !== undefined)? itemTouched[index]: {};
    //                         }

    //                         if(itemErrors){
    //                             itemErrors = (itemErrors[index] !== undefined)? itemErrors[index]: {};
    //                         }

    //                         return (
    //                             <Grid key={index} item xs={12} sm={12} md={12}>

    //                                 <Grid container spacing={0.5} >
    //                                     <Grid item xs={12} sm={12} md={5}>
    //                                         <TextField
    //                                             margin="normal"
    //                                             size="small"
    //                                             fullWidth
    //                                             name={`rows.${index}.slotName`}
    //                                             label="Name"
    //                                             type="text"                                         
    //                                             variant="outlined"
    //                                             value={itemValues?.slotName? itemValues.slotName : ""}
    //                                             onChange={handleChange}
    //                                             error={Boolean(itemErrors?.slotName)}
    //                                             helperText={itemErrors?.slotName}
    //                                         />
    //                                     </Grid>

    //                                     <Grid item xs={12} sm={12} md={2}>
    //                                         <TextField
    //                                             margin="normal"
    //                                             size="small"
    //                                             fullWidth
    //                                             name={`rows.${index}.slotSequence`}
    //                                             label="Sequence"
    //                                             type="text"                                         
    //                                             variant="outlined"
    //                                             value={itemValues?.slotSequence? itemValues.slotSequence : ""}
    //                                             onChange={handleChange}
    //                                             error={Boolean(itemErrors?.slotSequence)}
    //                                             helperText={itemErrors?.slotSequence}
    //                                         />
    //                                     </Grid>

    //                                     <Grid item xs={12} sm={12} md={2} display={"flex"} justifyContent={"center"} alignItems={"center"}>
    //                                         <FormGroup
    //                                             sx={{
    //                                             }}
    //                                         >
    //                                             <FormControlLabel
    //                                                 value="end"
    //                                                 control={
    //                                                     <Checkbox 
    //                                                         name={`rows.${index}.slotStatus`}
    //                                                         value={itemValues.slotStatus} 
    //                                                         checked={Boolean(itemValues.slotStatus)}
    //                                                         onChange={handleChange} 
    //                                                     />
    //                                                 }
    //                                                 label="Active"
    //                                                 labelPlacement="end"
    //                                             />
    //                                         </FormGroup>
    //                                     </Grid>

    //                                     <Grid item xs={12} sm={12} md={2} display={"flex"} justifyContent={"center"} alignItems={"center"}>
    //                                         <FormGroup
    //                                             sx={{
    //                                             }}
    //                                         >
    //                                             <FormControlLabel
    //                                                 value="end"
    //                                                 control={
    //                                                     <Checkbox 
    //                                                         name={`rows.${index}.defaultSlot`}
    //                                                         value={itemValues.defaultSlot} 
    //                                                         checked={Boolean(itemValues.defaultSlot)}
    //                                                         onChange={(event) => {

    //                                                             // mark all others checkbox is false
    //                                                             rows.forEach((e, indexE) => {
    //                                                                 // console.log('e', indexE)
    //                                                                 if(indexE !== index)
    //                                                                     setFieldValue(`rows.${indexE}.defaultSlot`, false)
    //                                                             })
                                                                    
    //                                                             setFieldValue(`rows.${index}.defaultSlot`, Boolean(event.target.value))

    //                                                         }} 
    //                                                     />
    //                                                 }
    //                                                 label="Default"
    //                                                 labelPlacement="end"
    //                                             />
    //                                         </FormGroup>
    //                                     </Grid>

    //                                     <Grid item xs={12} sm={12} md={1} alignSelf={"center"}>
    //                                         <Button 
    //                                             aria-label="delete"
    //                                             color="error"
    //                                             onClick={() => handleDeleteRow(index)}
    //                                             variant={"outlined"}
    //                                         >
    //                                             <CommonIcons
    //                                                 name={icons.remove}
    //                                             />
    //                                         </Button>
    //                                     </Grid>

    //                                 </Grid>
    //                             </Grid>
    //                         )
    //                     })
    //                 }
    //             </Box>

    //             <Grid container>
    //                 <Grid item xs={12} sm={12} md={12}>
                        
    //                     <Button 
    //                         variant="outlined" 
    //                         sx={{ mt: 2 }} 
    //                         fullWidth 
    //                         startIcon={<CommonIcons name={icons.add} />}
    //                         onClick={() => handleAddItem() }
    //                     >
    //                         Add Item
    //                     </Button>

    //                 </Grid>
    //             </Grid>

    //         </Box>
    //     )
    // }

    const RenderForm = () => {
        
        return(
            
            <form onSubmit={handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0}>
                        
                        <Grid item xs={12} sm={12} md={12}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="status" 
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.status)? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>
                                {/* <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="defaultStatus" 
                                                checked={Boolean(values.defaultStatus)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("defaultStatus", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.defaultStatus)? "Default" : "Not Default"
                                        }
                                    />
                                </Grid> */}

                                <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="rackType" 
                                                checked={Boolean(values.rackType)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("rackType", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.rackType)? t("reserved") : t("normal")
                                        }
                                    />
                                </Grid>
                            
                                <Grid item xs={12} sm={12} md={10}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"rackName"}
                                        label={t("rackName")}
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.rackName}
                                        onChange={handleChange}
                                        error={touched.rackName && Boolean(errors.rackName)}
                                        helperText={touched.rackName && errors.rackName}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name={"sequence"}
                                        label={t("sortNo")}
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.sequence}
                                        onChange={handleChange}
                                        error={touched.sequence && Boolean(errors.sequence)}
                                        helperText={touched.sequence && errors.sequence}
                                    />
                                </Grid>
                            
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>
                <Box 
                    sx={{ 
                        mx: 2,
                        mr: 2
                    }}
                >
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        loading={isLoading}
                    >
                        {t('saveChanges')}
                    </LoadingButton>
                </Box>
            </form>
                
        )
    }

    return (
        <Box>

            { RenderForm() }

        </Box>
    )
}